import { createCompositeMediaInlineCaption as caption } from './caption';
import { createCompositeMediaInlineStandard as standard } from './standard';
import { createCompositeMediaInlineWrapped as wrapped } from './wrapped';

export const createCompositeMediaInline = {
  caption,
  standard,
  wrapped,
};
